import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IPuntoCampionamentoTipologia } from './punti-campionamento-tipologie.model';
import { ITableColumn } from 'src/app/core/models/table.model';

export const PUNTICAMPIONAMENTOTIPOLOGIE_ENDPOINT = 'tipo-punto-campionamento';
export const PUNTICAMPIONAMENTOTIPOLOGIE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PUNTICAMPIONAMENTOTIPOLOGIE_ENDPOINT);

export const puntiCampionamentoTipologieStateConfig: SignalStoreConfig<QueryState<IPuntoCampionamentoTipologia>> = {
  initState: {
    list: [],
    sort: {
      field: 'codice',
      direction: 'asc'
    }
  }
}

export const PUNTICAMPIONAMENTOTIPOLOGIE_COLUMNS: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'id',
    primaryKey: true,
    visible: false
  },
  {
    name: 'codice',
    label: 'Codice',
    field: 'codice',
  },
  {
    name: 'descrizione',
    label: 'Descrizione',
    field: 'descrizione',
  },
];
